import { useRouter } from 'next/router'
import striptags from 'striptags'

import Button from 'components/Button'
import Image from 'components/Image'
import Link from 'components/Link'

import { eventConversion } from 'lib/gtag'
import { getOptimizedImageUrl } from 'lib/image'

import Styled from './styled'

export default function SectionBanner({ data }) {
  const router = useRouter()

  const slug = router?.query?.slug
  const desktopImage = data?.image?.url
  const altDesktopImage = data?.image?.alternativeText
  const mobileImage = data?.mobileImage?.url
  const altMobileImage = data?.mobileImage?.alternativeText
  const text = data?.title
  const buttonText = data?.button?.title
  const link = `/${slug}/booking`

  return (
    <Styled>
      <div className="banner-block">
        <picture>
          {mobileImage && (
            <source
              media="(max-width: 768px)"
              srcSet={getOptimizedImageUrl(mobileImage, 750)}
            />
          )}
          <source
            media="(min-width: 769px)"
            srcSet={getOptimizedImageUrl(desktopImage, 1920)}
          />
          <Image
            className="banner-image-desktop"
            src={desktopImage}
            alt={altDesktopImage || altMobileImage || text?.replace(/<[^>]*>/g, '')}
            imgixWidth={750}
            lazyload={false}
            fetchpriority="high"
          />
        </picture>

        <div className="container">
          <h1 className="banner-title-block">{striptags(text || '')}</h1>

          <div className="banner-button-block">
            {slug === 'garage' ? (
              <Button
                dynamic
                className="btn"
                onClick={() => {
                  eventConversion()
                  router.push(link)
                }}
              >
                {buttonText}
              </Button>
            ) : (
              <Link href={link}>
                <Button dynamic className="btn">
                  {buttonText}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </Styled>
  )
}
